<template>
    <Dialog ref="deleteTag">
      <template #expander="{ openModal }">
        <button
          type="button"
          class="pe-row-action-btn"
          aria-label="Delete tag"
          @click.stop="openModal"
        >
          <PhTrash :size="16" weight="bold" />
        </button>
      </template>
      <template #dialog.title>Warning</template>
      <template #dialog.content="{ closeModal, closeModalAfter }">
          <div class="delete-item-form">
            <div class="confirmation-text">
                Are you sure you want to delete this item?
            </div>
            <div class="form-buttons">
              <ButtonCustomized label="Cancel" @click="closeModal" secondary />
              <ButtonCustomized label="Delete" @click="onSave" />
            </div>
          </div>
      </template>
    </Dialog>
  </template>
    
  <script lang="ts" setup>
  import Dialog from '../../../components/Dialog/Dialog.vue';
  import ButtonCustomized from "../../../components/form-fields/ButtonCustomized.vue";
  import { PhTrash } from '@phosphor-icons/vue';
  import { ref } from 'vue';

  const emit = defineEmits(['cancel', 'save', 'exit', 'fail'])
  const deleteTag = ref()

  async function onSave() {
      emit('save');
      deleteTag.value.closeModal()
  }
  
  </script>
    
  <style lang="scss" scoped>
  .pe-row-action-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--bui-tbl-rowbtn-size, 28px);
    height: var(--bui-tbl-rowbtn-size, 28px);
    padding: 0;
    border: 0;
    border-radius: var(--bui-tbl-rowbtn-radius, 32px);
    background: transparent;
    color: var(--bui-tbl-rowbtn-color, #2a2a30);
    cursor: pointer;

    &:hover {
      background: var(--bui-tbl-rowbtn-hover-fill, #ececf0);
    }

    &:focus-visible {
      outline: 2px solid var(--bui-chk-checked-fill, #2a2a30);
      outline-offset: 2px;
    }
  }

  .delete-item-form {
      display: flex;
      flex-direction: column;
      max-width: 30rem;
    }
    .form-buttons {
      display: flex;
      justify-content: flex-end;
      gap: 0.75rem;
      margin-top: 1rem;
    }
  </style>
